<template>
  <div class="alipay-auth-callback">
    <div class="result-container">
      <div class="result-header">
        <img class="logo-img" src="@assets/images/alipay.png" alt="支付宝" />
        <h1 class="title">欢迎使用支付宝授权</h1>
      </div>

      <div class="result-body">
        <div v-if="loading" class="status-card loading-card">
          <div class="loading-spinner"></div>
          <p class="status-title">正在处理授权结果</p>
          <p class="status-desc">请稍候...</p>
        </div>

        <div v-else-if="success" class="status-card success-card">
          <div class="status-icon success-icon">
            <svg viewBox="0 0 24 24" width="40" height="40">
              <path
                d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
                fill="#07c160"
              />
            </svg>
          </div>
          <p class="status-title">授权成功</p>
          <p class="status-desc">支付宝账号已成功绑定，请尽快返回原应用继续操作。</p>
          <div class="tip-box success-tip">
            <span class="tip-dot"></span>
            <span>您可切换回刚才的应用，无需重复授权</span>
          </div>
        </div>

        <div v-else class="status-card fail-card">
          <div class="status-icon fail-icon">
            <svg viewBox="0 0 24 24" width="40" height="40" fill="#ff4d4f">
              <path
                d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
              />
            </svg>
          </div>
          <p class="status-title">授权失败</p>
          <p class="status-desc">{{ message || "授权未完成，请返回原应用后重试。" }}</p>
          <div class="tip-box fail-tip">
            <span class="tip-dot"></span>
            <span>如多次失败，请返回原应用重新发起授权</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { verifyAlipayAuthCallback } from "@api/user";

export default {
  name: "AlipayAuthCallback",
  data() {
    return {
      loading: true,
      success: false,
      message: ""
    };
  },
  mounted() {
    this.handleCallback();
  },
  methods: {
    handleCallback() {
      const query = this.$route.query || {};

      if (!query.state) {
        this.loading = false;
        this.success = false;
        this.message = "缺少 state 参数";
        return;
      }

      verifyAlipayAuthCallback(query)
        .then(res => {
          this.success = true;
          this.message = res.msg || "授权成功";
        })
        .catch(err => {
          this.success = false;
          this.message = err.msg || "授权失败，请稍后重试";
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.alipay-auth-callback {
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 10vh 16px 24px;
  background: linear-gradient(180deg, #e8f3ff 0%, #f5f7fa 42%, #f5f7fa 100%);
}

.result-container {
  width: 100%;
  max-width: 420px;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(22, 119, 255, 0.12);
}

.result-header {
  padding: 28px 24px 22px;
  text-align: center;
  color: #fff;
  background: linear-gradient(135deg, #1677ff 0%, #0958d9 100%);
}

.logo-img {
  width: 56px;
  height: 56px;
  margin: 0 auto 18px;
  display: block;
  object-fit: contain;
}

.title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.result-body {
  padding: 32px 24px 36px;
}

.status-card {
  text-align: center;
}

.status-icon {
  width: 72px;
  height: 72px;
  margin: 0 auto 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.success-icon {
  background: #f0faf4;
}

.fail-icon {
  background: #fff1f0;
}

.loading-spinner {
  width: 44px;
  height: 44px;
  margin: 0 auto 18px;
  border: 3px solid #e6f0ff;
  border-top-color: #1677ff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.status-title {
  margin: 0 0 10px;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.status-desc {
  margin: 0;
  font-size: 15px;
  line-height: 1.7;
  color: #666;
}

.tip-box {
  display: flex;
  align-items: flex-start;
  margin-top: 24px;
  padding: 14px 16px;
  border-radius: 12px;
  font-size: 13px;
  line-height: 1.6;
  text-align: left;
}

.success-tip {
  background: #f7faff;
  border: 1px solid #e6f0ff;
  color: #4a6fa5;
}

.fail-tip {
  background: #fff8f8;
  border: 1px solid #ffd6d6;
  color: #a85757;
}

.tip-dot {
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  margin: 8px 10px 0 0;
  border-radius: 50%;
  background: currentColor;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
